import moment from "moment";
import moment_tz from "moment-timezone";

export default {
  formatTZ(date) {
    var tz = moment_tz.tz.guess();
    return moment(date)
      .tz(tz)
      .format();
  },
  startMonth(when, pre) {
    return moment()
      .month(new Date().getMonth() + (when == "start" ? -1 : 0))
      .date(new Date().getDate() - (when == "start" ? -1 : 1))
      .hours(when == "start" ? 0 : 24)
      .minutes(when == "start" ? 0 : 59)
      .seconds(when == "start" ? 0 : 59)
      .milliseconds(when == "start" ? 0 : 59)
      .format("YYYY-MM-DD");
  },
  formatNormal(date, format) {
    return moment(date)
      .locale("es-mx")
      .format(format ? format : undefined);
  },
  today(format) {
    let today = new Date().toISOString().slice(0, 10);
    return format
      ? moment()
          .locale("es-mx")
          .format(format == "tz" ? undefined : format)
      : today;
  },
  diff(date) {
    let today = new Date().toISOString().slice(0, 10);
    return today.diff(date, "days");
  },
  diffTwoDates(date1, date2, type) {
    const startTime = moment(date1, "YYYY/MM/DD HH:mm");
    const endTime = moment(date2, "YYYY/MM/DD HH:mm");
    return endTime.diff(startTime, type, true) + " Horas";
  },
  hourAdd(hour, type) {
    const durationInMinutes = "30";
    let endTime = hour;
    if (type == "add") {
      endTime = moment(hour, "HH:mm:ss")
        .add(durationInMinutes, "minutes")
        .format("HH:mm");
    }
    if (type == "subtract") {
      endTime = moment(hour, "HH:mm:ss")
        .subtract(durationInMinutes, "minutes")
        .format("HH:mm");
    }
    return endTime;
  },
  timeZone() {
    return moment.tz.guess();
  },
};
